import ApiService from "./api.service";

const V2PromotionService = {
  async available() {
    try {
      return await ApiService.get("user/v2-promotions");
    } catch (error) {
      return error.response;
    }
  },

  async show(promotionId) {
    try {
      return await ApiService.get(`user/v2-promotions/${promotionId}`);
    } catch (error) {
      return error.response;
    }
  },

  async signIn(promotionId) {
    try {
      return await ApiService.post(`v2-promotions/${promotionId}/sign-in`);
    } catch (error) {
      return error.response;
    }
  },

  async signOut(promotionId) {
    try {
      return await ApiService.delete(`v2-promotions/${promotionId}/sign-out`);
    } catch (error) {
      return error.response;
    }
  },
};

export { V2PromotionService };
